export default "__VITE_ASSET__ba8ed413__"